// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { deleteAISettingsRequestToJson, deleteAISettingsResponseFromJson, discardMessageDraftRequestToJson, discardMessageDraftResponseFromJson, generateDraftPreviewRequestToJson, generateDraftPreviewResponseFromJson, getAISettingsRequestToJson, getAISettingsResponseFromJson, getMultiMessageDraftRequestToJson, getMultiMessageDraftResponseFromJson, listMessageDraftsRequestToJson, listMessageDraftsResponseFromJson, sendMessageDraftRequestToJson, sendMessageDraftResponseFromJson, upsertAISettingsRequestToJson, upsertAISettingsResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function generateDraftPreview(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/GenerateDraftPreview', generateDraftPreviewRequestToJson(request));
    return generateDraftPreviewResponseFromJson(raw);
}
export function generateDraftPreview$(request, options) {
    return defer(() => generateDraftPreviewWithTransport$(getGlobalTransport(), request, options));
}
export function generateDraftPreviewWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/GenerateDraftPreview', generateDraftPreviewRequestToJson(request), options)
        .pipe(map(resp => generateDraftPreviewResponseFromJson(resp)));
}
export async function sendMessageDraft(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/SendMessageDraft', sendMessageDraftRequestToJson(request));
    return sendMessageDraftResponseFromJson(raw);
}
export function sendMessageDraft$(request, options) {
    return defer(() => sendMessageDraftWithTransport$(getGlobalTransport(), request, options));
}
export function sendMessageDraftWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/SendMessageDraft', sendMessageDraftRequestToJson(request), options)
        .pipe(map(resp => sendMessageDraftResponseFromJson(resp)));
}
export async function discardMessageDraft(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/DiscardMessageDraft', discardMessageDraftRequestToJson(request));
    return discardMessageDraftResponseFromJson(raw);
}
export function discardMessageDraft$(request, options) {
    return defer(() => discardMessageDraftWithTransport$(getGlobalTransport(), request, options));
}
export function discardMessageDraftWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/DiscardMessageDraft', discardMessageDraftRequestToJson(request), options)
        .pipe(map(resp => discardMessageDraftResponseFromJson(resp)));
}
export async function listMessageDrafts(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/ListMessageDrafts', listMessageDraftsRequestToJson(request));
    return listMessageDraftsResponseFromJson(raw);
}
export function listMessageDrafts$(request, options) {
    return defer(() => listMessageDraftsWithTransport$(getGlobalTransport(), request, options));
}
export function listMessageDraftsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/ListMessageDrafts', listMessageDraftsRequestToJson(request), options)
        .pipe(map(resp => listMessageDraftsResponseFromJson(resp)));
}
export async function getMultiMessageDraft(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/GetMultiMessageDraft', getMultiMessageDraftRequestToJson(request));
    return getMultiMessageDraftResponseFromJson(raw);
}
export function getMultiMessageDraft$(request, options) {
    return defer(() => getMultiMessageDraftWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiMessageDraftWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/GetMultiMessageDraft', getMultiMessageDraftRequestToJson(request), options)
        .pipe(map(resp => getMultiMessageDraftResponseFromJson(resp)));
}
export async function getAISettings(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/GetAISettings', getAISettingsRequestToJson(request));
    return getAISettingsResponseFromJson(raw);
}
export function getAISettings$(request, options) {
    return defer(() => getAISettingsWithTransport$(getGlobalTransport(), request, options));
}
export function getAISettingsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/GetAISettings', getAISettingsRequestToJson(request), options)
        .pipe(map(resp => getAISettingsResponseFromJson(resp)));
}
export async function upsertAISettings(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/UpsertAISettings', upsertAISettingsRequestToJson(request));
    return upsertAISettingsResponseFromJson(raw);
}
export function upsertAISettings$(request, options) {
    return defer(() => upsertAISettingsWithTransport$(getGlobalTransport(), request, options));
}
export function upsertAISettingsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/UpsertAISettings', upsertAISettingsRequestToJson(request), options)
        .pipe(map(resp => upsertAISettingsResponseFromJson(resp)));
}
export async function deleteAISettings(request) {
    const raw = await fetchRpc('conversation.v1.ConversationAIService/DeleteAISettings', deleteAISettingsRequestToJson(request));
    return deleteAISettingsResponseFromJson(raw);
}
export function deleteAISettings$(request, options) {
    return defer(() => deleteAISettingsWithTransport$(getGlobalTransport(), request, options));
}
export function deleteAISettingsWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.ConversationAIService/DeleteAISettings', deleteAISettingsRequestToJson(request), options)
        .pipe(map(resp => deleteAISettingsResponseFromJson(resp)));
}
